module.exports = __webpack_public_path__ + "static/img/identity.5d2be05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/identity.png
// module id = exBE
// module chunks = 1